(function () {
  var STICKY_DELAY_PX = 150;

  function init() {
    var root = document.querySelector('.elvtd-product-variant-list');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.variant-card'));
    if (!cards.length) return;

    var mq = window.matchMedia('(max-width: 767px)');
    var ticking = false;

    function clearAll() {
      cards.forEach(function (card) {
        var buyArea = card.querySelector('.variant-buy-area');
        if (buyArea) buyArea.classList.remove('is-sticky');
      });
    }

    function update() {
      ticking = false;

      if (!mq.matches) {
        clearAll();
        return;
      }

      cards.forEach(function (card) {
        var buyArea = card.querySelector('.variant-buy-area');
        if (!buyArea) return;

        var rect = card.getBoundingClientRect();
        var appeared = window.innerHeight - rect.top >= STICKY_DELAY_PX;
        buyArea.classList.toggle('is-sticky', appeared);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', update);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(update);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
